import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { customerPermissionsPageDataResource } from '@jira/router-resources__service-desk-customer-permissions/src/customerPermissionsPageDataResource.tsx';
import { projectSettingsCustomerServiceManagementCustomerPermissionsRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceManagementCustomerPermissionsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { serviceDeskCustomerPermissionsEntrypoint } from '@jira/spa-apps__project-settings-service-desk-customer-permissions/src/serviceDeskCustomerPermissionsEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsCustomerServiceManagementCustomerPermissionsPageEntrypoint =
	createPageEntryPoint({
		main: serviceDeskCustomerPermissionsEntrypoint,
	});

export const projectSettingsCustomerServiceManagementCustomerPermissionsRouteEntry: Route =
	createEntry(projectSettingsCustomerServiceManagementCustomerPermissionsRoute, () => ({
		group: 'project-settings-customer-service',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			fg('csm_appification_standalone_navigation')
				? projectSettingsCustomerServiceManagementCustomerPermissionsPageEntrypoint
				: notFoundPageEntrypoint,
		resources: [
			...getServiceDeskSettingsResources(),
			customerPermissionsPageDataResource,
			getConsolidationStateResource(),
		],
		forPaint: [LazyAtlassianNavigation],
		meta: {
			reporting: {
				id: APP_NAMES.CUSTOMER_PERMISSIONS,
				packageName: toPackageName(APP_NAMES.CUSTOMER_PERMISSIONS),
				teamName: 'jsd-flux-capacitors',
			},
		},

		perfMetricKey: 'jsm-customer-permissions',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
